import { MARQUEE_ITEMS } from "@/data/site";
import { useLocale } from "@/context/LocaleContext";

export const Marquee = ({ className = "" }) => {
  const { t } = useLocale();
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className={`overflow-hidden border-y border-wood/15 py-4 select-none ${className}`} aria-hidden="true">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {items.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-mono text-xs uppercase tracking-[0.35em] text-wood/70">
                <span className="px-6">{t(item)}</span>
                <span className="text-terra">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
